import propertyTableMockDate from './propertyTableMockData.json';
const propertyTableData = propertyTableMockDate;

export default propertyTableData;
